import { styled, createTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ButtonBase from '@mui/material/ButtonBase';
import { Colors } from '../../theme';

const barBackground = `linear-gradient(90deg, ${Colors.BG_START} 0%, ${Colors.BG_END} 100%)`;

// Alto real de la pantalla: en celulares 100vh incluye la barra del navegador.
export const MapRoot = styled('div')(() => ({
  position: 'relative',
  display: 'flex',
  width: '100%',
  height: '100vh',
  overflow: 'hidden',
  '@supports (height: 100dvh)': {
    height: '100dvh',
  },
}));

export const HeaderCard = styled('header')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: '50%',
  transform: 'translateX(-50%)',
  width: 'min(560px, calc(100% - 24px))',
  height: 64,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '0 0 20px 20px',
  background: barBackground,
  boxShadow: `0 8px 24px ${Colors.SHADOW_CARD}`,
  zIndex: 1,
  [theme.breakpoints.up('sm')]: {
    height: 80,
    borderRadius: '0 0 25px 25px',
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  color: Colors.WHITE,
  fontSize: '1.75rem',
  fontWeight: 'bold',
  letterSpacing: 1,
  [theme.breakpoints.up('sm')]: {
    fontSize: '2.5rem',
  },
}));

export const BellButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  right: 8,
  transform: 'translateY(-50%)',
  color: Colors.WHITE,
  [theme.breakpoints.up('sm')]: {
    right: 16,
  },
}));

export const TextParragraph = styled(Typography)(() => ({
  color: Colors.WHITE,
  fontSize: '1rem',
  fontWeight: 'bold',
  lineHeight: 1.3,
}));

const PLAN_TONE_COLORS = {
  ok: Colors.TEXT_ON_DARK_MUTED,
  warning: Colors.WARNING_ON_DARK,
  error: Colors.ERROR_TEXT_LIGHT,
};

export const PlanButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'tone',
})(({ tone }) => ({
  alignSelf: 'center',
  gap: 2,
  padding: '2px 6px 2px 10px',
  borderRadius: 8,
  fontFamily: 'inherit',
  fontSize: '0.85rem',
  fontWeight: 600,
  color: PLAN_TONE_COLORS[tone] || Colors.TEXT_ON_DARK_MUTED,
  '@media (hover: hover)': {
    '&:hover': {
      background: Colors.INPUT_ON_DARK,
    },
  },
  '&.Mui-focusVisible': {
    outline: `2px solid ${Colors.GREEN_BACKGROUND}`,
  },
}));

export const FooterHint = styled(Typography)(() => ({
  color: Colors.TEXT_ON_DARK_MUTED,
  fontSize: '0.85rem',
  fontWeight: 600,
}));

export const FooterContainer = styled('footer')(() => ({
  position: 'absolute',
  bottom: 0,
  left: '50%',
  transform: 'translateX(-50%)',
  width: 'min(560px, 100%)',
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  padding: '12px 16px calc(10px + env(safe-area-inset-bottom))',
  borderRadius: '20px 20px 0 0',
  background: barBackground,
  boxShadow: `0 -8px 24px ${Colors.SHADOW_CARD}`,
  color: Colors.WHITE,
  textAlign: 'center',
}));

// El selector trae 24px de margen arriba: el contenedor queda justo debajo del encabezado.
export const MapSelectorContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 48,
  left: '50%',
  transform: 'translateX(-50%)',
  width: 'min(480px, calc(100% - 48px))',
  zIndex: 1,
  [theme.breakpoints.up('sm')]: {
    top: 68,
  },
}));

export const themeSpeedDial = createTheme({
  components: {
    MuiSpeedDial: {
      styleOverrides: {
        fab: {
          color: Colors.BG_START,
          backgroundColor: Colors.GREEN_BACKGROUND,
          '&:hover': {
            backgroundColor: Colors.BLUE_BACKGROUND,
          },
        },
      },
    },
    MuiSpeedDialAction: {
      styleOverrides: {
        tooltipPlacementLeft: {
          whiteSpace: 'nowrap',
        },
        staticTooltipLabel: {
          borderRadius: '20px',
          backgroundColor: Colors.GRAY_BACKGROUND_MODAL,
          color: Colors.WHITE,
          fontWeight: '500',
        },
        fab: {
          backgroundColor: Colors.GRAY_BACKGROUND_MODAL,
          color: Colors.GREEN_BACKGROUND,
          '&:hover': {
            backgroundColor: Colors.GRAY_BACKGROUND_MODAL,
          },
        },
      },
    },
  },
});
